const stylesheet = (theme: any) => ({
  iconContainer: {
    position: "relative",
    float: "right",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    height: "24px",
    width: "24px",
    "&:hover": {
      cursor: "pointer"
    }
  },
  reposition: {
    height: "3px",
    width: "16px",
    border: "1px solid #6373A4",
    borderLeft: "none",
    borderRight: "none",
    display: "inline-block",
    verticalAlign: "middle",
    marginRight: "12px",
    cursor: "move"
  },
  container: {
    // height: "864px",
    height: "auto",
    width: "333px",
    position: "absolute",
    zIndex: "100",
    left: "120px",
    top: "30px",
    paddingLeft: "24px",
    paddingTop: "17px",
    paddingRight: "14px",
    paddingBottom: "12px",
    borderRadius: "8px",
    backgroundColor: "#FFFFFF",
    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
    userSelect: "none"
  },
  justifyCenter: {
    display: "flex",
    alignItems: "center"
  },
  section: {
    marginBottom: "22px",
    zIndex: 99999999,
    "&:hover": {
      cursor: "default"
    }
  },
  sectionHeadName: {
    height: "19px",
    color: "#051D39",
    fontSize: "16px",
    fontWeight: "500",
    lineHeight: "19px",
    display: "inline-block",
    verticalAlign: "middle",
    marginRight: "10px",
    marginLeft: "10px",
    userSelect: "none"
  },
  sectionHeadLine: {
    boxSizing: "border-box",
    border: "0.5px solid #D8DCE6",
    display: "inline-block",
    verticalAlign: "middle",
    height: "1px"
  },
  sectionItem: {
    display: "flex",
    alignItems: "center",
    marginTop: "12px",
    height: "20px",
    paddingLeft: "55px",
    zIndex: 99999999,
    "&:hover": {
      cursor: "default"
    }
  },
  sectionItemName: {
    display: "inline-block",
    verticalAlign: "middle",
    height: "16px",
    color: "#085FE5",
    fontSize: "12px",
    fontWeight: "500",
    lineHeight: "16px",
    marginLeft: "11px"
  },
  revertToDefault: {
    height: "15px",
    width: "94px",
    color: "#085FE5",
    fontSize: "12px",
    fontWeight: "500",
    lineHeight: "15px",
    cursor: "pointer"
  }
});

export default stylesheet;
try {
    // @ts-ignore
    styles.displayName = "styles";
    // @ts-ignore
    styles.__docgenInfo = { "description": "", "displayName": "styles", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/ProfileConfiguration/styles.ts#styles"] = { docgenInfo: styles.__docgenInfo, name: "styles", path: "src/shared/components/ProfileConfiguration/styles.ts#styles" };
}
catch (__react_docgen_typescript_loader_error) { }